import '.em{display:inline-flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.t{height:40px;}.ssr-plugin'
import '.fk{padding:8px;}.ssr-plugin'
import '.fp{width:360px;}.ssr-plugin'
import '.hb{transition-timing-function:ease-in-out;}.ssr-plugin'
import '.bc{overflow:hidden;}.ssr-plugin'
import '.ba{position:fixed;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import '.eq{outline:none;}.ssr-plugin'
import '.j{border:none;}.ssr-plugin'
import '.i{background:transparent;}.ssr-plugin'
import '.ca{font-size:14px;}.ssr-plugin'
import '.jp{font-weight:400;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.gi{padding:0 8px;}.ssr-plugin'
import '.jq{margin:0 4px;}.ssr-plugin'
import '.c5{width:1px;}.ssr-plugin'
import '.a4{height:16px;}.ssr-plugin'
import { LinkNode } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection, $setSelection } from 'lexical'
import { useEffect, useState } from 'react'
import { colors } from '../../../tokens/colors.js'
import { shadows } from '../../../utils/shadows.js'
import { radius } from '../../../utils/radius.js'
import { IconButton } from '../../IconButton/index.js'
import { useToast } from '../../Toast/index.js'
import { styled } from 'inlines'

function FloatingLinkPlugin() {
  const [editor] = useLexicalComposerContext()
  const [open, setOpen] = useState(false)
  const [prevValue, setPrevValue] = useState<string>()
  const [value, setValue] = useState<string>()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const toast = useToast()

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setOpen(false)
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [value, prevValue])

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection()

          if (!$isRangeSelection(selection)) return

          const root = editor.getRootElement()
          const anchor = selection.anchor.getNode()
          const anchorParent = anchor.getParent()
          const native = window.getSelection()

          const node =
            anchor instanceof LinkNode
              ? anchor
              : anchorParent instanceof LinkNode
                ? anchorParent
                : null

          if (node && root.contains(native.anchorNode)) {
            const rect = native.focusNode.parentElement.getBoundingClientRect()
            const x = rect.left
            const y = rect.top

            setPosition({ x, y: y + rect.height + 8 })
            setValue(node.__url)
            setPrevValue(node.__url)
            setOpen(true)

            return
          }

          setOpen(false)
          setValue('')
          setPrevValue('')
        })
      }),
    )
  }, [editor, value])

  return (
    <>
      {open && (
        <div className="em d t fk fp hb bc ba"
          style={{
            background: colors.neutralInverted100,
            border: `1px solid  ${colors.neutral20Adjusted}`,
            boxShadow: shadows.popoverSmall,
            borderRadius: radius[16],
            left: position.x,
            top: position.y,
          }}
        >
          <div className="a7 em c d a1 f"
          >
            <input className="al eq j i ca jp f am gi"
              // autoFocus={!value?.length}
              value={value}
              onChange={(e) => {
                setValue(e.target.value)
              }}
              placeholder="Add link"
              style={{
                color: colors.neutral80,
              }}
            />
            {value === prevValue ? (
              <>
                {value && (
                  <>
                    <IconButton
                      size="small"
                      icon="arrow-out"
                      tooltip="Open in new tab"
                      onClick={() => {
                        const val = value.includes('http')
                          ? value
                          : 'https://' + value

                        window.open(val, '_blank', 'noopener,noreferrer')
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                    <IconButton
                      size="small"
                      icon="copy"
                      tooltip="Copy link"
                      onClick={() => {
                        navigator.clipboard.writeText(value)
                        toast('Link copied', { icon: 'copy' })
                        editor.update(() => {
                          $setSelection(null)
                        })
                        setOpen(false)
                      }}
                    />
                  </>
                )}
                <div className="jq c5 a4"
                  style={{
                    background: colors.neutral20Adjusted,
                  }}
                />
                <IconButton
                  size="small"
                  icon="link-off"
                  tooltip="Remove link"
                  onClick={() => {
                    editor.update(() => {
                      const selection = $getSelection()
                      if (!$isRangeSelection(selection)) return

                      const nodes = selection.extract()
                      nodes.forEach((node) => {
                        const parent = node.getParent()
                        if (parent instanceof LinkNode) {
                          const children = parent.getChildren()
                          for (let i = 0; i < children.length; i++) {
                            parent.insertBefore(children[i])
                          }
                          parent.remove()
                        }
                      })
                    })
                  }}
                />
              </>
            ) : (
              <>
                <IconButton
                  size="small"
                  icon="checkmark-normal"
                  tooltip="Save changes"
                  keyHint="Enter"
                  onClick={() => {
                    editor.update(
                      () => {
                        const selection = $getSelection()
                        if (!$isRangeSelection(selection)) return
                        const nodes = selection.extract()
                        nodes.forEach((node) => {
                          const parent = node.getParent()
                          if (parent instanceof LinkNode) {
                            parent.setURL(value)
                          }
                        })
                        nodes[nodes.length - 1].selectEnd()
                      },
                      {
                        onUpdate: () => {
                          setOpen(false)
                        },
                      },
                    )
                  }}
                />
                <IconButton
                  size="small"
                  icon="close"
                  tooltip="Discard changes"
                  keyHint="Esc"
                  keyHintVisualOnly
                  onClick={() => {
                    setOpen(false)
                  }}
                />
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export { FloatingLinkPlugin }
